import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';
import { useUserStore } from '../store/user.store';
import { eventBus } from '../common/services/eventBus';
import { showToast } from '../common/UI/ToastNotification';
import AppGetIcon from '../common/UI/AppGetIcon';
import { toast } from 'react-toastify';

interface ProtectedRouteProps {
  redirectTo?: string;
}

const ProtectedRoute: React.FC<React.PropsWithChildren<ProtectedRouteProps>> = ({
  children,
  redirectTo = "/login",
}) => {
  const { loading, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const { clearStore } = useUserStore((state) => ({
    clearStore: state.clearStore,
  }));

  const toastShown = useRef(false);

  useEffect(() => {
    if (loading) return;

    if (!isAuthenticated) {
      if (!toastShown.current) {
        toast.warning(
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <AppGetIcon name="iconAlert" />
          No Autorizado
        </div>,
        { icon: false }
      );
      }
      navigate(redirectTo, { replace: true });
    }

    const handleAuthTokenExpired = (message: any) => {
      if (!toastShown.current) {
        clearStore();
        showToast(message, 'warning');
        setTimeout(() => {
          navigate(redirectTo);
        }, 6000);
        toastShown.current = true;
      }
    };

    const handleNetworkError = (message: any) => {
      showToast(message, 'error');
    };

    eventBus.on('authTokenExpired', handleAuthTokenExpired);
    eventBus.on('networkError', handleNetworkError);

    return () => {
      eventBus.off('authTokenExpired', handleAuthTokenExpired);
      eventBus.off('networkError', handleNetworkError);
    };
  }, [loading, isAuthenticated, navigate, redirectTo, clearStore]);

  if (loading || !isAuthenticated) {
    return null;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
